import { handleChangeController } from '@redux/actions/form';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import { editCollectionRegister } from '../../../redux/actions/form';
import { removeError } from '../../../redux/actions/validator';
import { useCollection } from '../../../utility/hooks/useCollection';
import { InputValidator } from './InputValidator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faClipboard,
  faClipboardCheck,
  faClipboardQuestion,
  faClipboardUser,
  faCopy,
} from '@fortawesome/free-solid-svg-icons';
import { copyInClipboard } from '../../../utility/helpers/copyInClipboard';
import { CopyInClipcoard } from './CopyInClipcoard';

export const Input = (properties) => {
  const {
    name,
    label,
    className = 'form-control',
    placeholder = label,
    containerClassname = '',
    styles,
    errMsg = 'Campo requerido',
    symbol = false,
    copyable = false,
    defecto = () => {},
    collection,
    onCustomChange = null,
    disabled = false,
    step = false,
    ...props
  } = properties;

  const dispatch = useDispatch();
  const { form, validator } = useSelector((state) => state);
  const nodeForm = useCollection().getCollectionNode(form, collection);
  const value = nodeForm?.[name] || '';

  const handleChange = ({ target }) => {
    const v =
      props.type === 'number'
        ? step
          ? parseFloat(target.value)
          : parseInt(target.value)
        : target.value
        ? target.value
        : null;
    if (collection.length === 0)
      dispatch(handleChangeController(target.name, v));
    else {
      // if (v === null && (props.type === 'date' || props.type === 'datetime-local')) {
      //     const newCollection = [...collection].slice(0, collection.length - 1)
      //     console.log(newCollection, collection, v)
      //     dispatch(editCollectionRegister(newCollection, { name: collection[collection.length - 1], value: v }))
      // } else {
      dispatch(
        editCollectionRegister(collection, { name: target.name, value: v }),
      );
      // }
    }
    dispatch(removeError(validator.errors));
    dispatch(handleChangeController('edited', true));
  };

  useEffect(() => {
    defecto(dispatch);
  }, [name]);

  return (
    <div className={containerClassname}>
      {label && (
        <label className="control-label d-flex justify-content-between ">
          {label}
          <div>
            {copyable && <CopyInClipcoard value={value} label={label} />}
            <InputValidator
              errMsg={errMsg}
              errors={validator.errors}
              target={name}
            />
          </div>
        </label>
      )}
      <InputGroup>
        <input
          {...props}
          style={{ ...styles }}
          className={`${className} ${
            validator.errors && validator.errors[name]
              ? 'borderless border-danger rounded'
              : ''
          }`}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onCustomChange ? onCustomChange : handleChange}
          autoComplete="off"
          disabled={disabled}
        />

        {symbol && (
          <InputGroupAddon addonType="append">
            <InputGroupText>{symbol}</InputGroupText>
          </InputGroupAddon>
        )}
      </InputGroup>
    </div>
  );
};
